module.exports = __webpack_public_path__ + "static/img/pay_succ_joychat.02a5e773.png";